import {TableProps} from "@amzn/awsui-components-react/polaris/table";

export interface InlineEditingHandlerAttributes {
    item: any,
    column: TableProps.ColumnDefinition<any> | null,
    newValue: any
}

export const NO_DATA_MESSAGE: string = "No data to display"

export const NO_MATCH_MESSAGE: string = "No match found"

export const MANAGE_EXCEPTIONS_TAB_URL_PREFIX: string = "/icAccountMapping/manageExceptions"

export const mappingUpdateMessage = (type: string) => {
    return `You have successfully set up ${type} mapping for the selected account.`
}